import {
  VALIDATION_RANGES,
  VALIDATION_MESSAGES,
  VALID_FUZZINESS_VALUES,
} from "../constants";

export const validateBoostValue = (value: number | string): string | null => {
  if (value === "" || value === undefined || value === null) return null;

  const numValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numValue)) return VALIDATION_MESSAGES.MUST_BE_NUMBER;
  if (numValue < VALIDATION_RANGES.BOOST_VALUE.min)
    return VALIDATION_MESSAGES.NEGATIVE_BOOST;
  if (numValue > VALIDATION_RANGES.BOOST_VALUE.max)
    return VALIDATION_MESSAGES.HIGH_BOOST;
  return null;
};

export const validateFuzziness = (value: number | string): string | null => {
  const stringValue = typeof value === "number" ? value.toString() : value;
  if (!VALID_FUZZINESS_VALUES.includes(stringValue.toUpperCase() as any)) {
    return VALIDATION_MESSAGES.INVALID_FUZZINESS;
  }
  return null;
};

export const validatePrefixLength = (value: number | string): string | null => {
  if (value === "" || value === undefined || value === null) return null;

  const numValue = typeof value === "string" ? parseInt(value) : value;
  if (isNaN(numValue)) return VALIDATION_MESSAGES.MUST_BE_NUMBER;
  if (numValue < VALIDATION_RANGES.PREFIX_LENGTH.min)
    return VALIDATION_MESSAGES.MUST_BE_ZERO_OR_GREATER;
  if (numValue > VALIDATION_RANGES.PREFIX_LENGTH.max)
    return VALIDATION_MESSAGES.HIGH_PREFIX_LENGTH;
  return null;
};

export const validateMaxExpansions = (
  value: number | string
): string | null => {
  if (value === "" || value === undefined || value === null) return null;

  const numValue = typeof value === "string" ? parseInt(value) : value;
  if (isNaN(numValue)) return VALIDATION_MESSAGES.MUST_BE_NUMBER;
  if (numValue < VALIDATION_RANGES.MAX_EXPANSIONS.min)
    return VALIDATION_MESSAGES.LOW_EXPANSIONS;
  if (numValue > VALIDATION_RANGES.MAX_EXPANSIONS.max)
    return VALIDATION_MESSAGES.HIGH_EXPANSIONS;
  return null;
};

export const validateSlop = (value: number | string): string | null => {
  if (value === "" || value === undefined || value === null) return null;

  const numValue = typeof value === "string" ? parseInt(value) : value;
  if (isNaN(numValue)) return VALIDATION_MESSAGES.MUST_BE_NUMBER;
  if (numValue < VALIDATION_RANGES.SLOP.min)
    return VALIDATION_MESSAGES.MUST_BE_ZERO_OR_GREATER;
  if (numValue > VALIDATION_RANGES.SLOP.max)
    return VALIDATION_MESSAGES.HIGH_SLOP;
  return null;
};

export const validateMinimumShouldMatch = (
  value: number | string
): string | null => {
  if (value === "" || value === undefined || value === null) return null;

  const numValue = typeof value === "string" ? parseInt(value) : value;
  if (isNaN(numValue)) return VALIDATION_MESSAGES.MUST_BE_NUMBER;
  if (numValue < VALIDATION_RANGES.MINIMUM_SHOULD_MATCH.min)
    return VALIDATION_MESSAGES.MUST_BE_ONE_OR_GREATER;
  if (numValue > VALIDATION_RANGES.MINIMUM_SHOULD_MATCH.max)
    return VALIDATION_MESSAGES.SHOULD_BE_50_OR_LESS;
  return null;
};

export const validateOneOrGreater = (value: number | string): string | null => {
  if (value === "" || value === undefined || value === null) return null;
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numValue)) return VALIDATION_MESSAGES.MUST_BE_NUMBER;
  if (numValue < 1) return VALIDATION_MESSAGES.MUST_BE_ONE_OR_GREATER;
  return null;
};

export const validateZeroOrGreater = (
  value: number | string
): string | null => {
  if (value === "" || value === undefined || value === null) return null;
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numValue)) return VALIDATION_MESSAGES.MUST_BE_NUMBER;
  if (numValue < 0) return VALIDATION_MESSAGES.MUST_BE_ZERO_OR_GREATER;
  return null;
};

// Generic range validator for numeric fields
export const createRangeValidator = (min: number, max: number) => {
  return (value: number | string): string | null => {
    if (value === "" || value === undefined || value === null) return null;
    const numValue = typeof value === "string" ? parseFloat(value) : value;
    if (isNaN(numValue)) return VALIDATION_MESSAGES.MUST_BE_NUMBER;
    if (numValue < min) {
      if (min === 0) return VALIDATION_MESSAGES.MUST_BE_ZERO_OR_GREATER;
      if (min === 1) return VALIDATION_MESSAGES.MUST_BE_ONE_OR_GREATER;
      return `Must be ${min} or greater`;
    }
    if (numValue > max) {
      if (max === 100) return VALIDATION_MESSAGES.SHOULD_BE_100_OR_LESS;
      if (max === 50) return VALIDATION_MESSAGES.SHOULD_BE_50_OR_LESS;
      if (max === 1000) return VALIDATION_MESSAGES.HIGH_EXPANSIONS;
      if (max === 100000) return VALIDATION_MESSAGES.HIGH_BOOST;
      return `Should be ${max} or less`;
    }
    return null;
  };
};
